const GET_ADMIN_NOTE = "admin_note_types"
const GET_ADMIN_NOTE_RECORD = "admin_note_types";

const ADMIN_NOTE = "admin_note_types/";

const MULTI_DELET = "admin_note_types/remove/bulk_delete";

export default { GET_ADMIN_NOTE, ADMIN_NOTE, MULTI_DELET,GET_ADMIN_NOTE_RECORD };
